import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function LoanAccounting({ children }) {
  return (
    <div>
      <CustomPageHeader icon='square-o' text='Loan Accounting' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanAccounting/index.js